/* @flow */

import clsx from 'clsx';
import * as React from 'react';

import type { BasicFunction } from '../../helpers/jsHelpers/types';

import Localizer from '../../helpers/localization';
import { PictoArrowLeft, PictoArrowLeftWithShaft } from '../pictos/Element';
import './ButtonBack.css';

type PropType = {
  +'aria-label'?: string,
  +className: string,
  +hasShaft?: boolean,
  +hasText?: boolean,
  +onClick: (event: SyntheticMouseEvent<HTMLElement> | SyntheticTouchEvent<HTMLElement>) => Promise<void> | void,
  +onMouseEnter?: BasicFunction,
  +onMouseLeave?: BasicFunction,
};

const ButtonBack = (buttonBackProps: PropType): React.Node => {
  const { 'aria-label': ariaLabel, className, hasShaft = false, hasText = true, onClick, onMouseEnter, onMouseLeave } = buttonBackProps;

  return (
    <button
      aria-label={ariaLabel ?? Localizer.localize('accessibility.common.back')}
      className={clsx('backButtonBase', className)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      type='button'
    >
      {hasShaft === true ? <PictoArrowLeftWithShaft forceHoverEffect /> : <PictoArrowLeft forceHoverEffect />}
      {hasText ? <div className='text'>{Localizer.localize('common.actions.back')}</div> : null}
    </button>
  );
};

export default ButtonBack;
